import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to get the tier query parameter from the URL.
 * Returns undefined if not present.
 *
 * Used to filter product tiers on public pricing pages when tabs are removed.
 * Example: ?tier=enterprise filters to show only Professional and Enterprise cards.
 */
export const useTierQueryParam = () => {
  const location = useLocation();
  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('tier') || undefined;
  }, [location.search]);
};